import {ContactTypes} from "../utils/constants";

export default function ContactCell({ contact, edit, del, onSuccess, className, widthClass='', ...props}) {
  return (
    <>

      <div className={"d-flex justify-content-between align-items-center bg-light-lighten p-2 rounded gap-2 mb-2 "+className}>
        <div className={widthClass ? widthClass : ''}>
          <span className="me-2">
            {contact?.type===ContactTypes.email.val && <span className="dripicons-mail"></span>}
            {contact?.type===ContactTypes.tel.val && <span className="dripicons-phone"></span>}
          </span>
          <strong>{contact.contact}</strong>
          {contact.title && <div>{contact.title}</div>}
        </div>
        {(edit||del) && <div className={"d-inline-flex"}>
          {edit && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-primary ms-1" onClick={()=>edit(contact)}><span className="mdi mdi-pencil" title="Upraviť"></span></button>}
          {del && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-danger ms-1" onClick={()=>del(contact)}><span className="mdi mdi-trash-can" title="Zmazať"></span></button>}
        </div>}
      </div>
    </>
  );
}
